import { Banner, FetchConfig } from 'src/redux/apiTypes';
import { requestGetPartners } from './requestGetPartners';

export function getFetcher(url: string, fetchConfig: FetchConfig): () => Promise<Banner[]> {
  return function () {
    return requestGetPartners(url, fetchConfig);
  };
}
